import { palette } from 'main/ui'
import * as React from 'react'

interface IProps {
  count: number
}

const CircleCount = ({ count }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill={palette.poppy2}
      stroke="none"
    >
      <g>
        <circle cx="12" cy="12" r="10" />
        <text x="50%" y="50%" textAnchor="middle" stroke="white" strokeWidth="2px" dy=".3em">
          {count}
        </text>
      </g>
    </svg>
  )
}

export default React.memo(CircleCount)
